import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  return (
    <main className=" dapp_finr mete_versr_nft mining tradingbot">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <Helmet>
        <title>AI Crypto Trading Bot Development Company</title>

        <meta
          name="title"
          content="AI Crypto Trading Bot Development Company "
        />
        <meta
          name="description"
          content="Looking for a reliable AI Crypto Trading Bot Development Company? Choose a team like Beleaf Technologies for expert solutions. Our skilled developers create user-friendly trading bots, optimizing your cryptocurrency investments.  "
        />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/crypto-trading-bot-development-company"
        />
      </Helmet>
      <section className="cexnew_section1_ik bg_imgae_mining">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex align-items-center justify-content-center">
              <div className="cex_section1_content_ik content_merya_banner">
                <h1 className="text-center cryp-trade-mw">
                  AI Crypto Trading Bot Development Company
                </h1>
                <p className="cexnew_p_ik text-center">
                  Beleaf Technologies, your trusted partner in AI Crypto Trading
                  BoT Development Company. We pride ourselves on being the{" "}
                  <br /> go-to company for creating advanced trading bots that
                  redefine the crypto landscape.
                </p>
                <a
                  data-toggle="modal"
                  data-target="#myModal"
                  aria-label="Contact Us"
                  className="cexnew_button_ik"
                >
                  Get a demo
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section4_ik bg_section_bottom section_used_commenu pt-0 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img
                alt="AI Crypto Trading Bot Development Company"
                src={require("../../image/Tradingbot/bg_trade.webp")}
                className="img-fluid clor_img"
              ></img>
            </div>
            <div className="col-lg-6">
              <div className="cexnew_section4_title_ik ">
                <h2 className="cexnew_h2_ik">
                  What is AI Crypto Trading BoT Development?
                </h2>
                <p className="cexnew_p_ik">
                  AI Crypto Trading Bot Development involves creating intelligent
                  software programs (bots) that automatically trade
                  cryptocurrencies. These bots use algorithms to analyze market
                  trends, make decisions, and execute trades on behalf of users.
                  The primary goal is to maximize profits by taking advantage of
                  price fluctuations in the cryptocurrency market. This
                  technology eliminates the need for manual trading, operates
                  24/7, and is designed to enhance efficiency while mitigating
                  risks. In simpler terms, it's a smart way to get into the
                  complex world of cryptocurrency trading, allowing users to
                  benefit from market opportunities without constantly
                  monitoring the market themselves.
                </p>
                <a
                  data-toggle="modal"
                  data-target="#myModal"
                  className="cexnew_button_ik"
                >
                  Let's Talk
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section2_ik section_used_commenu bg_colore_for_mining pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex align-items-center  justify-content-center">
              <div className="cex_section2_content_ik mb-5">
                <h2 className="cexnew_h2_ik text-center">
                  Types of AI Crypto Trading
                  <br /> Bots We Develop
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section3_ik section_used_commenu pt-0 bg_colore_for_mining">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT ">
                <div className="crd_minin">
                  <span>1</span>
                </div>
                <h3>Arbitrage Bot</h3>
                <p>
                  Trades using price differences across different exchanges for
                  profit.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <span>2</span>
                </div>
                <h3> MEV Bot</h3>
                <p>
                  Maximizes profits by favoriting transactions and exploiting
                  miner extractable value in DEX.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <span>3</span>
                </div>
                <h3> Sandwich Bot</h3>
                <p>
                  Executes trades strategically around significant market
                  movements, maximizing gains.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <span>4</span>
                </div>
                <h3>Crypto Telegram Trading Bot</h3>
                <p>
                  Integrates with Telegram for real-time trade execution and
                  market updates.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <span>5</span>
                </div>
                <h3>Discord Trading Bot</h3>
                <p>
                  Integrates with Discord server for real-time trade monitoring
                  and market updates to use monetizing options.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <span>6</span>
                </div>
                <h3>Triangle trading Bot</h3>
                <p>
                  This bot uses triangular trading strategy to execute trades
                  and make profit swiftly from the available opportunity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cexnew_section7_ik section_used_commenu bg_colore_for_mining tradoing_bot_sep_caed ">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="cexnew_section7_title_ik text-center top_elemen">
                <h2 className="cexnew_h2_ik text-left">
                  Benefits of AI Crypto Trading BoT Development Company
                </h2>
                <p className="cexnew_p_ik text-left">
                  Discover the advantages of using a Crypto Trading Bot
                  Development Company for efficient, automated trading. Maximize
                  profits with smart technology solutions.
                </p>

                <a
                  data-toggle="modal"
                  data-target="#myModal"
                  className="cexnew_button_ik"
                >
                  Make Profit
                </a>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row gap2_ik justify-content-center align-items-center card_align_centr">
                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik one_ik Card_metaNFT">
                    <h3 className="">Enhanced Efficiency</h3>
                    <p className="mb-0">
                      Our Crypto Trading BoT Development Company simplifies the
                      trading processes, reducing manual efforts and enhancing
                      overall efficiency.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik two_ik Card_metaNFT">
                    <h3 className="">24/7 Market Monitoring</h3>
                    <p className="mb-0">
                      Enjoy the advantage of round-the-clock market
                      surveillance, ensuring you never miss a profitable trading
                      opportunity.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik three_ik Card_metaNFT">
                    <h3 className="">Risk Mitigation</h3>
                    <p className="mb-0">
                      Our bots are equipped with risk management features,
                      preventing substantial losses and ensuring a more secure
                      trading experience.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik four_ik Card_metaNFT">
                    <h3 className="">Data-Driven Insights</h3>
                    <p className="mb-0">
                      Use advanced analytics and real-time data to make informed
                      decisions, giving you a competitive edge in the market.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik four_ik Card_metaNFT">
                    <h3 className=""> Customization</h3>
                    <p className="mb-0">
                      Develop your trading strategy with our flexible bots,
                      accommodating various preferences and risk appetites.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cexnew_section7_card_ik four_ik Card_metaNFT">
                    <h3 className=""> Continuous Improvement</h3>
                    <p className="mb-0">
                      Benefit from regular updates and improvements, keeping
                      your trading bot ahead of technological advancements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section7_ik section_used_commenu bg_colore_for_mining">
        <div className="container">
          <div className="row colomin_reverse">
            <div className="col-lg-7">
              <div className="row gap2_ik justify-content-center align-items-center card_align_centr">
                <div className="col-lg-12 col-md-6 d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/mining/algorithm.webp")}
                      ></img>
                    </div>
                    <h3> Advanced Algorithm Design</h3>
                    <p>
                      Our bots use sophisticated algorithms, staying ahead of
                      market trends and adapting to changing conditions.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6  d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/Tradingbot/shield.webp")}
                      ></img>
                    </div>
                    <h3>Security Measures</h3>
                    <p>
                      Strong security protocols safeguard your assets, ensuring
                      a safe and trustworthy trading environment. .
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6  d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/mining/ux-design.webp")}
                      ></img>
                    </div>
                    <h3>User-Friendly Interface</h3>
                    <p>
                      Experience hassle free trading and easy customization with
                      our user-friendly interfaces.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6  d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/Tradingbot/business-report.webp")}
                      ></img>
                    </div>
                    <h3> Real-Time Reporting</h3>
                    <p>
                      Stay informed with advanced reports and analytics,
                      tracking the performance of your trading bot.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6  d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/Tradingbot/exchange-rate.webp")}
                      ></img>
                    </div>
                    <h3>Multiple Exchange Integration</h3>
                    <p>
                      Our bots can easily integrate with various exchanges,
                      broadening your trading opportunities.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-6  d-flex">
                  <div className="Card_metaNFT">
                    <div className="crd_minin">
                      <img
                        alt="AI Crypto Trading Bot Development Company"
                        src={require("../../image/Tradingbot/board.webp")}
                        className="mb-4"
                      ></img>
                    </div>
                    <h3>Diverse Trading Strategies</h3>
                    <p>
                      Choose from a range of trading strategies, from arbitrage
                      to trend following, to align with your financial goals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="cexnew_section7_title_ik text-center top_elemen">
                <h2 className="cexnew_h2_ik text-right">
                  Features of Our AI Crypto Trading BoT Development Company
                </h2>
                <p className="cexnew_p_ik mb-4 text-right">
                  Take advantage of advanced features with our crypto trading
                  bot development. Enhance your trading experience with our
                  innovative solutions. Choose excellence today!
                </p>
                <a
                  href="https://wa.me/7904323274"
                  className="cexnew_button_ik ml-auto"
                >
                  Contact Our Experts
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section2_ik section_used_commenu bg_colore_for_mining pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex align-items-center  justify-content-center">
              <div className="cex_section2_content_ik mb-5">
                <h2 className="cexnew_h2_ik text-center">
                  Revenue Factors of <br />
                  AI Crypto Trading BoT Development
                </h2>
                <p className="cexnew_p_ik mb-4 text-center">
                  Know the key factors influencing revenue in cryptocurrency
                  trading bot development. Learn how strategic decisions impact
                  profitability, ensuring success in the changing world of
                  crypto trading
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cexnew_section3_ik section_used_commenu pt-0 bg_colore_for_mining mine_text_color">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT ">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/stock-market.webp")}
                  ></img>
                </div>
                <h3>Efficient Trading Strategies</h3>
                <p>
                  AI Crypto Trading Bot Development significantly boosts revenue by
                  implementing efficient and automated trading strategies. Bots
                  execute trades at high speed, taking advantage of market
                  opportunities in real-time.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/24-7.webp")}
                  ></img>
                </div>
                <h3>24/7 Trading Presence</h3>
                <p>
                  With continuous operation, trading bots ensure a constant
                  market presence. This uninterrupted activity allows for timely
                  responses to price fluctuations, potentially maximizing
                  profits
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/evaluation.webp")}
                  ></img>
                </div>
                <h3>Risk Management</h3>
                <p>
                  Incorporating strong risk management features into Crypto
                  Trading Bots helps protect investments. Automated bots can
                  swiftly respond to market indicators, mitigating potential
                  losses and preserving capital.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/speed.webp")}
                  ></img>
                </div>
                <h3>Speed and Accuracy</h3>
                <p>
                  Bots excel in executing trades with speed and precision,
                  reacting to market changes faster than human traders. This
                  ability can lead to improved trade execution and increased
                  profitability
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/analytics.webp")}
                  ></img>
                </div>
                <h3>Data Analysis</h3>
                <p>
                  Trading bots analyze vast amounts of market data to make
                  informed decisions. By processing information quickly and
                  accurately, these bots enhance the chances of identifying
                  profitable opportunities and trends.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className="Card_metaNFT">
                <div className="crd_minin">
                  <img
                    alt="AI Crypto Trading Bot Development Company"
                    src={require("../../image/Tradingbot/emotional-intelligence.webp")}
                  ></img>
                </div>
                <h3>Minimized Emotional Influence</h3>
                <p>
                  Emotions can impact trading decisions. Crypto Trading Bots
                  operate without emotional influence, sticking to predefined
                  strategies. This minimizes the risk of impulsive decisions and
                  enables a disciplined, systematic approach to trading,
                  potentially enhancing overall revenue.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="cexnew_section6_ik section_used_commenu pt-0 bg_colore_for_mining">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="cex_section6_img_ik">
                <img
                   alt="AI Crypto Trading Bot Development Company"
                  src={require("../../image/mining/whymining.webp")}
                ></img>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <div className="cex_section6_content_ik">
                <h2 className="cexnew_h2_ik">
                  <span className="cexnew_span_ik">Why Choose</span>
                  <br />
                  beleaf technologies for bitcoin mining software development?
                </h2>
                <p className="cexnew_p_ik mb-4">
                  Our experience and 100+ clients speaks more about our
                  expertise in bitcoin mining software development. We have a
                  well trained crew of developers to ensure the reliability of
                  the product. Rigorous testing is made to make sure your mining
                  operation dont stop at any cost. Our development process is
                  carefully monitored from requirement gathering to deployment
                  and also after deployment bug free support is given 24/7 . The
                  qualities make us outstand in the industry are
                </p>
                <ul className="code_image">
                  <li>Premium quality</li>
                  <li>24/7 Customer support</li>

                  <li>On time delivery</li>
                  <li>Data privacy</li>
                  <li>Customization</li>
                  <li>Customer Satisfaction</li>
                </ul>
                <a href="/contact-us" className="cexnew_button_ik">
                  Talk To Our Experts
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="cexnew_section8_ik section_used_commenu bg_colore_for_mining">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cexnew_section3_title_ik text-center">
                <h2 className="cexnew_h2_ik">
                  Why Choose Beleaf Technologies
                  <br /> AI Crypto Trading BoT Development Company?
                </h2>
                <p className="cexnew_p_ik">
                  Choosing Beleaf Technologies for your Crypto Trading Bot
                  development ensures a hassle free. journey into the world of
                  crypto trading. We stand out for our commitment to simplicity,
                  security, and personalized solutions. With us, you gain a
                  reliable partner offering user-friendly interfaces, strong
                  security measures, and continuous updates for optimal
                  performance. Our team is dedicated to making crypto trading
                  accessible and profitable, providing you with the confidence
                  to navigate the complexities of the market. Trust Beleaf
                  Technologies to simplify your crypto journey and open doors to
                  a smarter and more efficient trading experience.
                </p>

                <a
                  href="https://wa.me/7904323274"
                  className="cexnew_button_ik mx-auto b-block"
                >
                  Talk To Our Experts
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white paddng_100">
        <Section id="about why new_faq bg_white CEX_faq">
          <section className="section bg_white CEX_faq" id="">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 align-items-center">
                  <div className="whybelaf faq">
                    <h2 className="">
                      Frequently asked <br />
                      Question
                    </h2>
                    <p></p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="comtent">
                    <div id="main" className="mt-0">
                      <div className="container">
                        <div className="accordion" id="faq">
                          <div className="card">
                            <div className="card-header" id="faqhead1">
                              <a
                                href="#"
                                className="btn btn-header-link w-100"
                                data-toggle="collapse"
                                data-target="#faq1"
                                aria-expanded="true"
                                aria-controls="faq1"
                              >
                                How secure are our assets with your trading
                                bots?
                              </a>
                            </div>

                            <div
                              id="faq1"
                              className="collapse show"
                              aria-labelledby="faqhead1"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                We prioritize security. Our bots integrate
                                advanced encryption and authentication measures
                                to ensure the safety of your assets.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead2">
                              <a
                                href="#"
                                className="btn btn-header-link w-100 collapsed"
                                data-toggle="collapse"
                                data-target="#faq2"
                                aria-expanded="true"
                                aria-controls="faq2"
                              >
                                Can I customize the trading strategies of the
                                bot?
                              </a>
                            </div>

                            <div
                              id="faq2"
                              className="collapse"
                              aria-labelledby="faqhead2"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Absolutely! Our bots are designed for
                                flexibility, allowing you to develop trading
                                strategies to align with your unique goals.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead3">
                              <a
                                href="#"
                                className="btn btn-header-link w-100 collapsed"
                                data-toggle="collapse"
                                data-target="#faq3"
                                aria-expanded="true"
                                aria-controls="faq3"
                              >
                                How often are the bots updated?
                              </a>
                            </div>

                            <div
                              id="faq3"
                              className="collapse"
                              aria-labelledby="faqhead3"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                We are committed to continuous improvement. Our
                                bots undergo regular updates to incorporate the
                                latest market insights and technological
                                advancements.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead4">
                              <a
                                href="#"
                                className="btn btn-header-link w-100 collapsed"
                                data-toggle="collapse"
                                data-target="#faq4"
                                aria-expanded="true"
                                aria-controls="faq4"
                              >
                                Is customer support available?
                              </a>
                            </div>

                            <div
                              id="faq4"
                              className="collapse"
                              aria-labelledby="faqhead4"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Yes, our dedicated customer support team is
                                available around the clock to assist you with
                                any queries or concerns.
                              </div>
                            </div>
                          </div>
                          <div className="card">
                            <div className="card-header" id="faqhead5">
                              <a
                                href="#"
                                className="btn btn-header-link w-100 collapsed"
                                data-toggle="collapse"
                                data-target="#faq5"
                                aria-expanded="true"
                                aria-controls="faq5"
                              >
                                Which exchanges are compatible with your bots?
                              </a>
                            </div>

                            <div
                              id="faq5"
                              className="collapse"
                              aria-labelledby="faqhead5"
                              data-parent="#faq"
                            >
                              <div className="card-body">
                                Our bots are designed to seamlessly integrate
                                with a variety of exchanges, providing you with
                                diverse trading opportunities.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Section>
        {/* <Footer /> */}
        <ServiceFooter />
      </section>
    </main>
  );
}

export default Cex;
